function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
import { isSingleExpression as $ } from "./directive-helpers.js";
import { Directive as _, PartType as A } from "./directive.js";
import { directive as N } from "./directive.js"; /**
                                                 * @license
                                                 * Copyright 2017 Google LLC
                                                 * SPDX-License-Identifier: BSD-3-Clause
                                                 */
var _o = function o(t, e) {
    var i;
    var s = t._$AN;
    if (s === void 0) return !1;
    var _iterator = _createForOfIteratorHelper(s),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        (i = r._$AO) == null || i.call(r, e, !1), _o(r, e);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return !0;
  },
  h = function h(t) {
    var e, s;
    do {
      if ((e = t._$AM) === void 0) break;
      s = e._$AN, s.delete(t), t = e;
    } while ((s == null ? void 0 : s.size) === 0);
  },
  c = function c(t) {
    for (var e; e = t._$AM; t = e) {
      var s = e._$AN;
      if (s === void 0) e._$AN = s = new Set();else if (s.has(t)) break;
      s.add(t), d(e);
    }
  };
function f(t) {
  this._$AN !== void 0 ? (h(this), this._$AM = t, c(this)) : this._$AM = t;
}
function a(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var i = this._$AH,
    r = this._$AN;
  if (r !== void 0 && r.size !== 0) if (e) {
    if (Array.isArray(i)) for (var n = s; n < i.length; n++) _o(i[n], !1), h(i[n]);else i != null && (_o(i, !1), h(i));
  } else _o(this, t);
}
var d = function d(t) {
  var _t$_$AP, _t$_$AQ;
  t.type == A.CHILD && ((_t$_$AP = t._$AP) !== null && _t$_$AP !== void 0 ? _t$_$AP : t._$AP = a, (_t$_$AQ = t._$AQ) !== null && _t$_$AQ !== void 0 ? _t$_$AQ : t._$AQ = f);
};
var p = /*#__PURE__*/function (_ref) {
  function p() {
    var _this;
    _classCallCheck(this, p);
    _this = _callSuper(this, p, arguments), _this._$AN = void 0;
    return _this;
  }
  _inherits(p, _ref);
  return _createClass(p, [{
    key: "_$AT",
    value: function _$AT(e, s, i) {
      _superPropGet(p, "_$AT", this, 3)([e, s, i]), c(this), this.isConnected = e._$AU;
    }
  }, {
    key: "_$AO",
    value: function _$AO(e) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i, r;
      e !== this.isConnected && (this.isConnected = e, e ? (i = this.reconnected) == null || i.call(this) : (r = this.disconnected) == null || r.call(this)), s && (_o(this, e), h(this));
    }
  }, {
    key: "setValue",
    value: function setValue(e) {
      if ($(this._$Ct)) this._$Ct._$AI(e, this);else {
        var s = _toConsumableArray(this._$Ct._$AH);
        s[this._$Ci] = e, this._$Ct._$AI(s, this, 0);
      }
    }
  }, {
    key: "disconnected",
    value: function disconnected() {}
  }, {
    key: "reconnected",
    value: function reconnected() {}
  }]);
}(_);
export { p as AsyncDirective, _ as Directive, A as PartType, N as directive };